import { DEALER_BLOCKED_STATUSES } from 'Utilities/consts';

import useUser from './useUser';

export const useIsUserDisabled = () => {
	const user = useUser();

	if (!user || user?.isLoggedOut) {
		return true;
	}

	return DEALER_BLOCKED_STATUSES.has(user?.dealerStatus?.slug ?? '');
};
